// tslint:disable-next-line:no-var-requires
const _ = require('lodash');

import config from '../../config/office.json';

interface ConfigType {
  manager: { init_charge: number; monthly_charge: number };
}

type Manager = {
  initCharge: number;
  monthlyCharge: number;
};

type User = {
  initCharge: number;
  monthlyCharge: number;
  freeCount: number;
};

export class OfficeConfig {
  public manager: Manager;
  public user: User;

  constructor() {
    this.manager = {
      initCharge: config.manager.init_charge,
      monthlyCharge: config.manager.monthly_charge,
    };
    this.user = {
      initCharge: config.user.init_charge,
      monthlyCharge: config.user.monthly_charge,
      freeCount: config.user.free_count,
    };
  }
}
